import PropTypes from "prop-types";



export default function WelcomeInterface({ handleChatResponse }) {
  return (
    <div className="flex-1 mt-16 sm:mt-0 flex flex-col items-center justify-center p-6 overflow-y-auto h-full">
      <div className="max-w-2xl w-full text-left mb-4 sm:mb-12 sm:mt-8">
        <h1 className="font-hel text-2xl sm:text-4xl font-medium text-gray-800">
          Hello, this is{" "}
          <span className="text-[#52B12F] font-bold">DaburGPT</span>.
          <br />
          How may I assist you today?
        </h1>
      </div>


    </div>
  );
}

WelcomeInterface.propTypes = {
  handleChatResponse: PropTypes.func.isRequired,
};
